// extracted by mini-css-extract-plugin
module.exports = {"main":"CircleChart_main__332a4"};